<template>
  <div class="detailed_list">
    <Carousel :bannerImg="bannerImg" :bannerInfo="bannerInfo" />


    <div class="w detals_box flex">
      <!-- 侧边栏 -->
       <div>
         <div class="tabs">
           <a-collapse accordion v-model="activeIdx" expandIconPosition="right" :bordered="false" @change="formTabsClick">
             <a-collapse-panel key="1">
               <template slot="header">
                <!-- <img v-if="activeIdx == 1" src="../assets/icon/icon-response-blue.png" alt="" /> -->
                <img v-if="activeIdx == 1" src="../assets/icon/icon-response-red.svg" alt="" />
                <img v-else src="../assets/icon/icon-response-default.png" alt="" />
                <span class="title">责任清单</span>
               </template>
               <ul v-if="deptInfo.sectionInfoList?.length>0">
                 <li
                   :class="['li_yuan', index == tabsIdx ? 'tabs_li_bg' : '']"
                   v-for="(item, index) in deptInfo.sectionInfoList"
                   :key="item.id"
                   @click="changeTab(index,item)"
                 >
                   {{ item.name }}
                 </li>
               </ul>
             </a-collapse-panel>
             <a-collapse-panel key="2" :show-arrow="false" >
               <template slot="header">
                 <!-- <img v-if="activeIdx == 2" src="../assets/icon/icon-service-blue.png" alt="" /> -->
                 <img v-if="activeIdx == 2" src="../assets/icon/icon-service-red.svg" alt="" />
                 <img v-else src="../assets/icon/icon-service-default.png" alt="" />
                 <span class="title">服务清单</span>
               </template>
             </a-collapse-panel>
             <a-collapse-panel key="3" :show-arrow="false">
               <template slot="header">
                 <!-- <img v-if="activeIdx == 3" src="../assets/icon/icon-approval-blue.png" alt="" /> -->
                 <img v-if="activeIdx == 3" src="../assets/icon/icon-approval-red.svg" alt="" />
                 <img v-else src="../assets/icon/icon-approval-default.png" alt="" />
                 <span class="title">审批清单</span>
               </template>
             </a-collapse-panel>
           </a-collapse>
         </div>
       </div>
      <!-- 表单 -->
      <div class="form">
        <div class="form_title">{{ deptInfo.name }}</div>
        <div class="form_con">
          <div class="flex">
            <div class="form_con_info phone">
              联系电话：<span>{{ deptInfo.contact }}</span>
            </div>
            <div class="form_con_info">办公地址：{{ deptInfo.address }}</div>
          </div>
          <div class="form_con_info">办公时间：{{deptInfo.workTime}}</div>
          <div>
            <div class="form_con_info">部门简介</div>
            <div :class="['dept_desc',deptInfo.introduction?.length>120&&ifHidden?'ellipsis':'']">{{ deptInfo.introduction }}</div>
            <template v-if="deptInfo.introduction?.length>120">
              <div class="show_more" @click="showMore" v-if="ifHidden">
                展开<a-icon type="down" />
              </div>
              <div class="show_more" @click="showMore" v-else>
                收起<a-icon type="up" />
              </div>
            </template>
          </div>
        </div>
        <!-- 三张清单 -->
        <div class="flex form_navi">
          <!-- <div class="flex" style="border-bottom: 1px solid #ebeffc">
            <div
              v-for="(item, index) in formTabs"
              :key="index"
              :class="[
                'form_box',
                index == 0 ? '' : 'form_cls',
                formTabsIdx == index ? 'click_sty' : '',
              ]"
              @click="formTabsClick(index, item)"
            >
              {{ item }}
            </div>
          </div> -->
          <div class="dept_name" v-if="activeIdx==1">{{deptName}}</div>
          <div v-else>
            <a-input
            placeholder="请输入你要查询的关键字..."
            :maxLength="30"
            :allowClear="true"
            @search="onSearch"
          /></div>
          <div class="total_date">
            共收录部门{{ formName }} <span>{{ pagination.total }}</span> 条
          </div>
        </div>
        <!-- 责任清单 -->
        <!-- <div class="form_table" v-if="formTabsIdx == 0">
          <div class="form_top form_list flex">
            <div class="form_orderBy">序号</div>
            <div class="form_value">责任描述</div>
          </div>
          <div class="form_list flex" v-for="item in responseList1" :key="item.id">
            <div class="form_orderBy">{{item.id}}</div>
            <div class="form_value">{{item.desc}}</div>
          </div>
        </div> -->
        <div v-if="activeIdx == 1" style="margin-bottom: 13.125rem">
          <a-table
            :columns="resColumns"
            :data-source="responseList"
            :pagination="pagination"
            rowKey="id"
            :loading="loading"
            bordered
            @change="pageChange"
          ></a-table>
        </div>
        <!-- 服务清单 -->
        <div v-if="activeIdx == 2" style="margin-bottom: 13.125rem">
          <a-table
            :columns="serColumns"
            :data-source="serviceList"
            :pagination="pagination"
            rowKey="id"
            :loading="loading"
            bordered
            @change="pageChange"
          >
          <template slot="serviceClassifyNameList" slot-scope="scope">
            <span v-for="item in scope" :key="item">{{ item }}&nbsp;&nbsp;</span>
          </template>
          <template slot="targets" slot-scope="scope">
            <span v-for="item in scope" :key="item">{{ item }}&nbsp;&nbsp;</span>
          </template>
            <template slot="operation" slot-scope="scope, row">
              <div class="flex">
                <div class="bon_l" @click="gotoDetails(row.manageId)">查看详情</div>
                <div :class="[row.isApply?'bon_r':'disable_class']" @click="gotoWork(row.isApply,row.pcUrl)">{{row.isApply?'线上办理':'线下办理'}}</div>
              </div>
            </template>
          </a-table>
        </div>
        <!-- 审批清单 -->
        <div v-if="activeIdx == 3" style="margin-bottom: 13.125rem">
          <a-table
            :columns="approvalColumns"
            :data-source="approvalList"
            :pagination="pagination"
            rowKey="id"
            :loading="loading"
            bordered
            @change="pageChange"
          >
          <template slot="serviceClassifyNameList" slot-scope="scope">
            <span v-for="item in scope" :key="item">{{ item }}&nbsp;&nbsp;</span>
          </template>
          <template slot="targets" slot-scope="scope">
            <span v-for="item in scope" :key="item">{{ item }}&nbsp;&nbsp;</span>
          </template>
          <!-- <template slot="manageType" slot-scope="scope">{{ scope==1?'办事类':'应用类' }}</template> -->
            <template slot="operation" slot-scope="scope, row">
              <div class="flex">
                <div class="bon_l" @click="gotoDetails(row.manageId)">查看详情</div>
                <div :class="[row.isApply?'bon_r':'disable_class']" @click="gotoWork(row.isApply,row.pcUrl)">{{row.isApply?'线上办理':'线下办理'}}</div>
              </div>
            </template>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from '../components/Carousel.vue';
import imgPrefix from '../../utils/imgPrefix'
import {usageLogsApi,findDepartmentApi,findNavBannerApi,findDeptByIdApi,findLiabilitiesApi,findListServiceApi,findApprovalApi,countWayNumberByListServiceApi} from '../api/index'
const resColumns = [
  {
    title: "序号",
    dataIndex: "orderBy",
    width: 80,
  },
  {
    title: "责任描述",
    dataIndex: "description",
  },
];
const serColumns = [
  {
    title: "序号",
    dataIndex: "orderBy",
    width: 80,
  },
  {
    title: "事项名称",
    dataIndex: "serviceManageName",
  },
  {
    title: "主管部门",
    dataIndex: "departmentName",
  },
  {
    title: "服务主题",
    dataIndex: "serviceClassifyNameList",
    scopedSlots: { customRender: "serviceClassifyNameList" },
    width:150
  },
  {
    title: "服务对象",
    dataIndex: "targets",
    scopedSlots: { customRender: "targets" },
    width:100
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
    width:180
  },
];
const approvalColumns = [
  {
    title: "序号",
    dataIndex: "orderBy",
    width: 80,
  },
  {
    title: "事项名称",
    dataIndex: "serviceManageName",
  },
  // {
  //   title: "事项类型",
  //   dataIndex: "manageType",
  //   scopedSlots: { customRender: "manageType" },
  // },
  {
    title: "主管部门",
    dataIndex: "departmentName",
  },
  {
    title: "服务主题",
    dataIndex: "serviceClassifyNameList",
    scopedSlots: { customRender: "serviceClassifyNameList" },
  },
  {
    title: "服务对象",
    dataIndex: "targets",
    scopedSlots: { customRender: "targets" },
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
  },
];
export default {
  props: {},
  components: {Carousel},
  data() {
    return {
      activeIdx: 1,
      tabsIdx: 0,
      formName: "责任清单",
      loading:false,
      tabsList: [],
      deptInfo:{sectionInfoList:[]},
      formTabs: ["责任清单", "服务清单", "审批清单"],
      // formTabs: ["责任概况", "权责清单",],
      // formTabsIdx: 0,
      responseList: [],
      resColumns,
      serColumns,
      approvalColumns,
      serviceList: [],
      approvalList: [],
      page:1,
      pageSize:10,
      pagination: {
        total: 0,
        current:1,
        showTotal: (total) => `当前有${total}条部门记录  每页显示 1~10条`,
      },
      deptId:'', //部门id
      bannerImg: [],
      bannerInfo:{
        title:'三张清单',
        desc:'主要工作职责，具体工作事项以及落实、督促、检查各项工作职责的制度措施；'
      },
      imgPrefix,
      offLineNumber:0,
      onLineNumber:0,
      ifEllipsis: false,
      deptName: '',
      sectionInfoId: '',
      ifHidden: true, //为true时折叠部门简介
    };
  },
  computed: {},
  watch: {
    // 监听路由对象中的property变化
    '$route': {
      handler: function (to, from) {
        // 路由变化时的处理逻辑
        // console.log('Route changed from', from.path, 'to', to.path);
        if(to.path == '/detailedList'){
          location.reload()
        }
      },
      // 设置为true则是深度监听
      deep: true
    }
  },
  created() {
    console.log(this.$route,'-----------');
    let { deptId } = this.$route.query;
    this.deptId = deptId;
    this.getDeptInfo(deptId)
    this.getBanner();
    this.getcountWayNumber(deptId)
    // 获取部门
    // findDepartmentApi().then((res) => {
    //   console.log(res,'部门列表');
      
    //   this.tabsList = res || [];
    //   if(res.length > 0){
    //     this.deptName = res[0].name
    //     this.getDeptInfo(res[0].id)
    //     this.deptId = res[0].id;
    //     this.getcountWayNumber(res[0].id)
    //   }
    //   this.getTabelList(1)
    // });
  },
  mounted() {},
  methods: {
     // 获取banner
     getBanner() {
      let naviTop = JSON.parse(sessionStorage.getItem("naviArr"));
      naviTop.forEach(item => {
        if (item.link == "/detailedList") {
          findNavBannerApi(item.id)
            .then((res) => {
              // console.log(res);
              this.bannerImg = res;
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        }
      });
    },
    // 获取部门下面的科室和信息
    getDeptInfo(id){
      findDeptByIdApi(id).then(res => {
        console.log(res,'------');
        this.deptInfo = res;
        let arr = res?.sectionInfoList || []
        
        if(arr?.length > 0){
          this.sectionInfoId = arr[0].id;
          this.deptName = arr[0].name;
          this.getTabelList(1)
        }
      }).catch((err) => {
          this.loading = false;
          this.$message.error(err.message)
        });
    },
    onSearch(e){
      console.log(e);
      
    },
    // 获取表单
    getTabelList(e){
      console.log(e,'eee---------');
      let dto = {
        page: this.page,
        pageSize: this.pageSize,
      }      
      if(e == 1){
        dto.sectionId = this.sectionInfoId;
      }else{
        dto.deptId = this.deptId;
      }
      this.loading = true;
      let api = e==1?findLiabilitiesApi:e==2?findListServiceApi:findApprovalApi;
      api(dto).then(res => {
        // console.log(res);
        res.voList.list.forEach((item,idx) => {
          item.orderBy = (this.page-1)*this.pageSize+idx+1;
        })        
        this.pagination.total = res.voList.total;
        this.pagination.current = res.voList.page;
        this.loading = false;
        if(e==1){
          this.responseList=res.voList.list;
        }else if(e==2){
          this.serviceList=res.voList.list;
        }else if(e==3){
          this.approvalList=res.voList.list;
        }
      }).catch((err) => {
          this.loading = false;
          this.$message.error(err.message)
        });
    },
    // 通过部门id统计服务清单的线上线下数量
    getcountWayNumber(id){
      countWayNumberByListServiceApi(id).then(res => {
        console.log(res);
        this.offLineNumber = res.offLineNumber;
        this.onLineNumber = res.onLineNumber;
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 选择课室
    changeTab(idx,item) {
      this.page = 1;
      this.tabsIdx = idx;
      this.formName = "责任清单";
      this.deptName = item.name;
      this.sectionInfoId = item.id;
      this.getTabelList(this.activeIdx)     
    },
    // 切换清单tab栏
    formTabsClick(e) {
      this.page = 1;
      this.formName = e == 1 ? '责任清单':e == 2 ? '服务清单':'审批清单';
      this.responseList = [];
      this.serviceList = [];
      this.approvalList = [];
      this.getTabelList(e)      
    },
    // 查看指南
    gotoDetails(id) {
      let dto = {
        "serviceId": id,
        "userId": "",
       }
       let userId = sessionStorage.getItem('userId');
       if(userId){
        dto.userId = userId;
       }
      usageLogsApi(dto).then(res => {})
      const url = this.$router.resolve({ path: `/serviceDetails?serviceManageId=${id}` }).href;
      window.open(url, '_blank');
      // let naviTop = JSON.parse(sessionStorage.getItem('naviArr'))
      // naviTop.forEach(item => {
      //   if(item.link == '/serviceHall'){
      //     this.$router.push("/serviceDetails?naviId=" + item.id + "&serviceManageId=" + id);      
      //   }
      // });

    },
    gotoWork(isApply,url) {
      if(isApply){
        window.open(url)
      }
    },
    showMore(){
      this.ifHidden = !this.ifHidden;
    },
    // 切换页码
    pageChange(pagination) {
      this.current = pagination.current;
      this.page =  pagination.current;
      this.getTabelList(this.activeIdx)
    },
  },
};
</script>

<style scoped lang="less">
.theme_color{
  color: var(--themeColor);
}
.detailed_list {
  .detals_box {
    align-items: normal;
    margin-top: 40px;
    .tabs {
      width: 13.25rem;
      border-radius: 8px;
      border: 1px solid #EBEFFC;
      padding: 12px;
      background: #fff;
      ul {
        border-right: 1px solid #edf1fd;
        margin-bottom: 0;
        overflow-y: auto;
        max-height: 400px;
        margin-bottom: 24px;
        li {
          padding: 16px 8px;
          position: relative;
          text-align: left;
          cursor: pointer;
          font-size: 16px;
        }
        // .li_yuan::before {
        //   content: "";
        //   position: absolute;
        //   top: 44%;
        //   left: 9%;
        //   width: 6px;
        //   height: 6px;
        //   background: var(--themeColor);
        //   border-radius: 50%;
        // }
      }
    }
    .tabs_li_bg {
      border-left: 2px solid var(--themeColor);
      background: linear-gradient(
        90deg,
        #f7f8fc 0%,
        rgba(224, 229, 240, 0) 100%
      );
    }
    .form {
      margin-left: 48px;
      width: 80%;
      .form_title {
        font-size: 24px;
        font-weight: 700;
        text-align: left;
        margin-bottom: 21px;
      }
      .form_con {
        text-align: left;
        padding-left: 13px;
        .form_con_info {
          position: relative;
          margin-bottom: 8px;
          span {
            color: var(--themeColor);
          }
        }
        .form_con_info::before {
          content: "";
          position: absolute;
          top: 37%;
          left: -13px;
          width: 6px;
          height: 6px;
          background: var(--themeColor);
          border-radius: 50%;
        }
        .phone {
          margin-right: 10.9rem;
        }
        .dept_desc {
          font-size: 14px;
          color: #7a8ba4; 
          // max-height: 42px;
        }
        .show_more{
          margin-top: 7px;
          padding: 4px 6px;
          border-radius: 4px;
          background: #F1F2F3;
          color: var(--themeColor);
          font-size: 12px;
          display: flex;
          align-items: center;
          cursor: pointer;
          justify-content: space-between;
          max-width: 52px;
          img{
            width: 12px;
            height: 12px;
          }
        }
      }
      .form_navi {
        margin-top: 43px;
        margin-bottom: 1.5rem;
        justify-content: space-between;
        .form_box {
          padding-bottom: 11px;
          color: #374567;
          margin-left: 35px;
          margin-right: 35px;
          position: relative;
          cursor: pointer;
          &:first-child {
            margin-left: 0;
          }
           &:last-child {
            margin-right: 0;
          }
        }
        // .form_box div:first-child{
        //   margin-left: 0;
        // }
        .click_sty {
          color: var(--themeColor);
          border-bottom: 2px solid var(--themeColor) !important;
        }
        .form_cls::after {
          content: "";
          position: absolute;
          width: 1px;
          height: 16px;
          background: #ebeffc;
          top: 9%;
          left: -62%;
        }
        .total_date {
          span {
            color: rgba(255, 122, 0, 1);
          }
        }
        .dept_name{
          padding-left: 16px;
          font-size: 16px;
          position: relative;
        }
        .dept_name::after{
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 4px;
          height: 20px;
          background: var(--themeColor);
        }
      }
      .form_table {
        border-top: 1px solid #e0e5f0;
        border-left: 1px solid #e0e5f0;
        margin-bottom: 13.125rem;
        .form_top {
          color: #7a8ba4;
          background: #ebeffc;
        }
        .form_list {
          border-bottom: 1px solid #e0e5f0;
          border-right: 1px solid #e0e5f0;
          .form_orderBy {
            width: 10%;
            padding: 0.875rem 14px;
          }
          .form_value {
            flex: 1;
            border-left: 1px solid #e0e5f0;
            padding: 0.775rem 14px;
          }
          .form_service_name {
            width: 40%;
            flex: auto;
          }
        }
      }
      .bon_l {
        border: 1px solid var(--themeColor);
        border-radius: 8px;
        padding: 6px 8px;
        color: var(--themeColor);
        margin-right: 12px;
        cursor: pointer;
        text-align: center;
      }
      .bon_r {
        color: #fff;
        background: var(--themeColor);
        border-radius: 8px;
        padding: 6px 8px;
        cursor: pointer;
        text-align: center;
      }
    }
  }
}
.ellipsis{
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
li{
  list-style: none;
}
/deep/.ant-table-pagination.ant-pagination {
  display: flex!important;
  float: none!important;
}
/deep/.ant-pagination-total-text {
  flex: 1!important;
  text-align: left;
}
/deep/.ant-table-thead > tr > th, 
/deep/.ant-table-tbody > tr > td{
  padding: 16px 8px;
}

// 折叠面板最后两个内容高度设置为0
/deep/.ant-collapse-item:last-child .ant-collapse-content,
/deep/.ant-collapse-item:nth-last-child(2) .ant-collapse-content {
  height: 0;
  border-top: none;
}
.ant-collapse-borderless{
  background: #fff;
}
.ant-collapse-borderless > .ant-collapse-item{
  border-bottom: none;
}
/deep/.ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header{
  font-size: 18px;
  text-align: left;
  img{
    margin-right: 7px;
  }
}
/deep/.ant-collapse-item-active .title{
  color: var(--themeColor);
}

/deep/.ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header{
  border-radius: 4px;
  border: 1px solid #E0E5F0;
  padding: 24px 12px !important;
  margin-bottom: 20px;

}
/deep/.ant-collapse-item-active .ant-collapse-header{
  border: 1px solid #0061AE !important;
  background: rgba(0, 93, 169, 0.10);
}
/deep/.ant-collapse-content > .ant-collapse-content-box{
  padding: 0 !important;
}
/deep/.ant-btn-primary {
  background: var(--themeColor);
}

/* 自定义整个滚动条 */
::-webkit-scrollbar {
  width: 6px; /* 设置滚动条的宽度 */
  background-color: #f9f9f9; /* 滚动条的背景色 */
}
 
/* 自定义滚动条轨道 */
::-webkit-scrollbar-track {
  background: #e1e1e1; /* 轨道的背景色 */
  border-radius: 10px; /* 轨道的圆角 */
}
 
/* 自定义滚动条的滑块（thumb） */
::-webkit-scrollbar-thumb {
  background-color: #c1c1c1; /* 滑块的背景色 */
  border-radius: 5px; /* 滑块的圆角 */
}
 
/* 当滑块悬停或活动时的样式 */
::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8; /* 悬停或活动状态下的背景色 */
}

</style>
